import { render, staticRenderFns } from "./GrowthCurves.vue?vue&type=template&id=1ad0b8cb"
import script from "./GrowthCurves.vue?vue&type=script&lang=js"
export * from "./GrowthCurves.vue?vue&type=script&lang=js"
import style0 from "./GrowthCurves.vue?vue&type=style&index=0&id=1ad0b8cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports